export default __webpack_public_path__ + "static/img_3_2-a1072c9df9819eb517f28d113d444fff.jpg";